<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Sklad metal konto</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 lg3>
                <dodavatele all v-model="dodavatel"></dodavatele>
              </v-flex>
              <v-flex xs12 sm6 lg3>
                <material all v-model="material"></material>
              </v-flex>
              <v-flex class="fill-width">
                <!--<date-range-picker
                      @update="console.log(value)"
                      :locale-data="locale"
                    >
                </date-range-picker>-->
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                :loading="loadingTable"
              >
                <template slot="items" slot-scope="props">
                  <td><strong v-if="!props.item.dodavatel.metal_konto">Interní - </strong>{{ props.item.dodavatel.nazev }}</td>
                  <td>{{ props.item.material.nazev }}</td>
                  <td class="text-xs-right">{{ props.item.stav_konta | formatMoney }} g</td>
                  <td class="text-center">
                    <router-link :to="{ path: '/sklad-metal-konto/' + props.item.id }">
                      <v-btn color="primary" class="elevation-0">
                      <v-icon small class="mr-2">swap_horiz</v-icon> Pohyby</v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      loadingTable: false,
      headers: [
        { text: 'Dodavatel', value: 'dodavatel.nazev' },
        { text: 'Materiál', value: 'material.nazev' },
        { text: 'Množství na skladě', value: 'stav_konta', align: 'right' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: [],
      dodavatel: null,
      material: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
  			this.load();
  		},
  		deep: true
  	},
    dodavatel () {
      this.load();
    },
    material () {
      this.load();
    }
  },
  methods: {
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sklady/metal-konto/search", {
        echo: this.counter,
        dodavatel: this.dodavatel,
        material: this.material
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Sklady/SkladMetalKonto.vue